<template>
  <v-dialog v-model="dialog" max-width="450">
    <v-btn color="white" flat icon slot="activator" @click.stop="onMainMenuClick">
      <v-icon>menu</v-icon>
    </v-btn>
    <v-card>
      <v-img src="https://res.cloudinary.com/ioty/image/upload/c_scale,w_500/v1511996040/app/img/savant-city.jpg" height="200px">
        <v-layout column class="media">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
        </v-layout>
      </v-img>
      <div v-for="item in filteredByAuthentication" :key="item.icon">
        <v-list two-line>
          <v-list-tile @click="handleClick(item.routeName)">
            <v-list-tile-action>
              <v-icon x-large color="secondary">{{item.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="primary--text">{{item.title}}</v-list-tile-title>
              <v-list-tile-sub-title>{{item.subTitle}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon color="secondary">arrow_forward</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </div>
      <Signup v-if="!userIsAuthenticated" @onSignupClicked="onSignupClicked"></Signup>
      <Signin v-if="!userIsAuthenticated" @onSigninClicked="onSigninClicked"></Signin>
    </v-card>
  </v-dialog>
</template>

<script>
import Signin from '../auth/Signin.vue'
import Signup from '../auth/Signup.vue'

export default {
  components: {
    Signin,
    Signup
  },
  data() {
    return {
      menuItems: [
        {
          icon: 'add_circle',
          routeName: 'ListProjects',
          title: 'New Design',
          subTitle: 'Create a new design project',
          status: 'authenticated'
        },
        {
          icon: 'person',
          routeName: 'Profile',
          title: 'My Profile',
          subTitle: 'View your details',
          status: 'authenticated'
        },
        {
          icon: 'lock',
          routeName: 'Signout',
          title: 'Sign out',
          subTitle: 'Sign out of your account',
          status: 'authenticated'
        }

      ]
    }
  },
  computed: {
    dialog: {
      get() { return this.$store.getters['common/menu'] },
      set(status) { this.$store.commit('common/SET_MENU', status)}
    },
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      )
    },
    userData() {
      return this.$store.getters.userData

    },
    filteredByAuthentication() {
      return this.menuItems.filter(item => {
        if (this.userIsAuthenticated) {
          return item.status === 'authenticated'
        } else {
          return item.status === 'notAuthenticated'
        }
      })
    }
  },
  methods: {
    handleClick(routeName) {
      if (routeName === 'Signout') {
        this.dialog = false
        this.onLogout()
      } else if (routeName === 'Profile') {
        this.dialog = false
        this.$router.push({
          name: routeName,
          params: { id: this.$store.getters.user.id }
        })
      } else {
        this.dialog = false
        this.$router.push({ name: routeName })
      }
    },
    onLogout() {
      this.dialog = false
      this.$emit('onLogout')
      this.$router.push({ name: 'Home' })
    },
    onSigninClicked() {
      this.$store.commit('clearError')
    },
    onSignupClicked() {
      this.$store.commit('clearError')
    },
    onMainMenuClick() {
      this.dialog = true
      this.$store.dispatch('common/clearMessage')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/MenuPop.vue